import { createStyles, makeStyles } from '@material-ui/core';

export const tableStyles = makeStyles(() =>
    createStyles({
        root: {
            width: '80vw',
            border: '2px solid rgb(231, 236, 242)',
            borderRadius: '0.5rem',
        },
        paper: {
            width: '100%',
        },
        table: {
            minWidth: 750,
        },
        tableContainer: {
            borderRadius: '0.5rem',
        },
    }),
);
